
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import RoutesNames from "@/entities/RouteTabs";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import Processing from "@/components/common/Processing.vue";
import CopyLink from "@/components/icons/CopyLinkGray.vue";
import CopyLinkHover from "@/components/icons/CopyLinkHover.vue";
import LIST_PROJECTS from "@/apollo/projects/ListProjects.gql";
import storage from "@/services/storage";
import Tooltip from "@/components/common/Tooltip.vue";
import TooltipVariants from "@/entities/TooltipVariants";
import PageInfo from "@/components/page/PageInfo.vue";
import StatusChip from "@/components/icons/StatusChip.vue";
import TabsWithRoutes from "@/components/common/TabsWithRoutesNew.vue";
import ResumeSidebar from "@/components/contractors/ResumeSidebar.vue";
import ContractorHeader from "@/components/contractors/ContractorHeaderNew.vue";
import MessageIcon from "@/components/icons/ChatIconNew.vue";
import MessageIconHover from "@/components/icons/ChatIconHoverNew.vue";
import DotIcon from "@/components/icons/DotIcon.vue";
import UIButton from "@/components/button/ui-button.vue";
import PageHeadIcon from "@/components/page/PageHeadIconNew.vue";
import Added_by from "@/apollo/managers/GetAddedByManager.gql";
import ContractorDetailedInformation from "@/components/contractors/CompanyContractorDetailedInformation.vue";
import DownloadResume from "@/components/profile/DownloadResume.vue";
import { Company, User, Project } from "@/generated/graphql";
import ChipStatus from "@/entities/ChipStatus";

@Component({
  components: {
    ContractorHeader,
    CopyLink,
    CopyLinkHover,
    DownloadResume,
    Processing,
    PageInfo,
    DotIcon,
    UIButton,
    TabsWithRoutes,
    PageHeadIcon,
    Tooltip,
    TooltipVariants,
    ResumeSidebar,
    StatusChip,
    MessageIcon,
    MessageIconHover,
    ContractorDetailedInformation,
  },
})
export default class ContractorAbout extends Vue {
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly contractorUser!: User;
  @Prop({ type: Boolean, required: true }) readonly hasAllResourceAccess!: boolean;
  @Prop({ type: Boolean, required: false, default: true })
  readonly isAdmin!: boolean;
  @Prop({ type: Boolean, required: false, default: true })
  readonly isContractorRequested!: boolean;
  @Prop({ type: Boolean, required: false, default: true })
  readonly isAccessGranted!: boolean;

  isHoveredCopy: boolean = false;
  isHoveredChat: boolean = false;
  fullname: String = "";
  TooltipVariants = TooltipVariants;

  get contractorFullName(): string {
    if (!this.contractorUser) {
      return "";
    }

    const firstName = this.contractorUser.given_name;
    const lastName = this.contractorUser.family_name;
    return `${firstName} ${lastName}`;
  }

  async handleCopy(res) {
    try {
      await navigator.clipboard.writeText(
        `${window.location.origin}/company_database/contractors/${res}/about`
      );
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(`URL copied to clipboard!`)
      );
    } catch (err) {}
  }

  downloadFile(): void {
    storage
      .get(this.contractorUser.profile.resume)
      .then((filePath) => {
        if (typeof filePath === "string") {
          window.open(filePath, "_self");
          return;
        }
        throw new Error("File not found");
      })
      .catch((e: Error) => {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
      });
  }

  get location(): string {
    const { country, state, city, address } = this.contractorUser.profile;
    const location = [address,city, state, country]
      .filter((place) => Boolean(place))
      .join(", ");
    return location.length > 0 ? location : null;
  }

  get contractorProjectsArgs(): any {
    const queryTemplate = {
      offset: null,
      // limit: null,
      where: {},
    };

    const generalCondition = {
      project_activities: {
        contractor: {
          user_id: {
            _eq: this.contractorUser.id,
          },
        },
      },
    };
    if (this.currentUser.role === "MANAGER") {
      queryTemplate.where = {
        _and: [
          generalCondition,
          {
            project_activities: {
              project: {
                manager: {
                  user_id: {
                    _eq: this.currentUser.id,
                  },
                },
              },
            },
          },
        ],
      };

      return queryTemplate;
    }

    queryTemplate.where = {
      _and: [
        generalCondition,
        {
          company: {
            admins: {
              user_id: {
                _eq: this.currentUser.id,
              },
            },
          },
        },
      ],
    };

    return queryTemplate;
  }

 get status(): ChipStatus {
    if (this.contractorUser.available) {
      return ChipStatus.ATTENTION;
    }

    return ChipStatus.INFO;
  }
  get getOccupation(): String | null {
    if (this.contractorUser?.profile?.job_title) {
      return this.contractorUser?.profile?.job_title;
    } else if (
      this.contractorUser &&
      this.contractorUser.experiences[0]?.job_title
    ) {
      return this.contractorUser.experiences[0].job_title;
    } else {
      return;
    }
  }

updateCrumb() {
        const breadcrubmData = document.querySelector(
            '.contractor_detail_crubm_li > span'
        );
        if (breadcrubmData) {
            breadcrubmData.innerHTML = `${this.contractorFullName}`;
        }
    }
    @Watch('contractorUser')
    crumbdata() {
        this.updateCrumb();
    }
    @Watch('$route', { immediate: true, deep: true })
    onUrlChange() {
        this.updateCrumb();
    }


  async fetchAddedBy(newValue) {
    try {
      if (newValue !== null) {
        const { data } = await this.$apollo.query({
          query: Added_by,
          variables: {
            id: this.contractorUser.created_by,
          },
        });
        this.fullname = `${data.user[0].given_name} ${data.user[0].family_name}`;
      } else {
        return "n/a";
      }
    } catch (error) {
      return "";
    }
  }

  get getCompany(): String | null {
    if (this.contractorUser?.profile?.company_name) {
      return this.contractorUser?.profile?.company_name;
    } else if (
      this.contractorUser &&
      this.contractorUser.experiences[0]?.company_name
    ) {
      return this.contractorUser.experiences[0].company_name;
    } else {
      return;
    }
  }

  get website(): String | null {
    if (this.contractorUser && this.contractorUser.profile) {
      if (this.contractorUser.profile.website) {
        return this.contractorUser.profile.website;
      }
    }
    return null;
  }

  // get phoneNumber(): Number | String | null {
  // 	if (
  // 		this.contractorDetail &&
  // 		this.contractorDetail.contractor_by_pk &&
  // 		this.contractorDetail.contractor_by_pk.user
  // 	) {
  // 		return this.contractorDetail.contractor_by_pk.user.private_data
  // 			.phone;
  // 	}
  // 	return null;
  // }

  get contractorRates(): string | undefined {
    if (this.contractorUser && this.contractorUser.profile) {
      const minRate = this.contractorUser.profile.min_rate;
      const maxRate = this.contractorUser.profile.max_rate;
      const currency = this.contractorUser.profile.currency;
      const rateUnit = this.contractorUser.profile.rate_unit;
      if (!minRate && !maxRate) {
        return;
      }

      if (!maxRate) {
        return `$${minRate} ${currency}/${rateUnit}`;
      }

      if (!minRate) {
        return `$${maxRate} ${currency}/${rateUnit}`;
      }

      return `$${minRate}-$${maxRate} ${currency}/${rateUnit}`;
    }
    return "";
  }

  get getJobType(): String {
    if (this.contractorUser && this.contractorUser.role) {
      return this.contractorUser.role;
    } else {
      return null;
    }
  }

  message(): void {
    this.$router.push({
      name: "inbox",
      query: {
        recipientUserId: this.contractorUser.id,
      },
    });
  }
}
